// #1179 FR-1 — the one "failed to load" state. A section that swallowed its
// fetch error used to fall through to its empty state, so a failed load read
// as "you have no data". Render this instead, and keep the empty copy for
// when the load succeeded and really returned nothing.

export const DEFAULT_LOAD_ERROR_MESSAGE = "We couldn't load this. Please try again."

const RETRY_CLASS =
  'mt-3 inline-flex items-center rounded-full border border-red-300 bg-white px-4 py-1.5 text-sm font-medium text-red-700 hover:bg-red-100'

interface LoadErrorProps {
  message?: string
  onRetry?: () => void
  // Server components cannot pass a handler — Retry reloads this URL instead.
  retryHref?: string
  className?: string
}

export function LoadError({ message = DEFAULT_LOAD_ERROR_MESSAGE, onRetry, retryHref, className = '' }: LoadErrorProps) {
  return (
    <div
      role="alert"
      data-testid="load-error"
      className={`rounded-xl border border-red-200 bg-red-50 p-6 text-center ${className}`}
    >
      <p className="text-sm text-red-700">{message}</p>
      {onRetry ? (
        <button type="button" onClick={onRetry} className={RETRY_CLASS}>
          Retry
        </button>
      ) : retryHref ? (
        <a href={retryHref} className={RETRY_CLASS}>
          Retry
        </a>
      ) : null}
    </div>
  )
}

// Inline message for a failed action (save, upload, submit) — replaces alert().
export function InlineError({ message, className = '' }: { message: string | null | undefined; className?: string }) {
  if (!message) return null
  return (
    <p role="alert" data-testid="inline-error" className={`text-sm text-red-600 ${className}`}>
      {message}
    </p>
  )
}
